
import { Materials } from './materials';


export class Packages {

    _materials: Materials[];
    private _model : any;
    constructor(private _modelDefined: any) {
        this._model = this._modelDefined ? angular.copy(this._modelDefined) : {};
        this.loadMaterials();
    }


    private loadMaterials() : void{

        if (this._model !== undefined && this._model.requestMaterials !== undefined && this._model.requestMaterials.length > 0) {
            this._materials = [];
            for (let material of this._model.requestMaterials) {
                this._materials.push(new Materials(material));
            }
        } 
    }

    get packageType(): string {
        return this._model.packageType;
    }

    set packageType(val: string) {
        this._model.packageType = val;
    }


    get length(): number {
        return this._model.length;
    }

    set length(val: number) {
        this._model.length = val;
    }

    get width(): number {
        return this._model.width;
    }

    set width(val: number) {
        this._model.width = val;
    }

    get height(): number {
        return this._model.height;
    }

    set height(val: number) {
        this._model.height = val;
    }

    get uom(): string {
        return this._model.uom;
    }

    set uom(val: string) {
        this._model.uom = val;
    }

    get quantity(): number {
        return this._model.quantity;
    }

    set quantity(val: number) {
        this._model.quantity = val;
    }

    get grossWeight(): number {
        return this._model.grossWeight;
    }

    set grossWeight(val: number) {
        this._model.grossWeight = val;
    }

    get materials(): Materials[] {
        return this._materials;
    }

    set materials(val: Materials[]) {

        this._materials = [];
        for (let mtrl of val) {
            this._materials.push(new Materials(mtrl));
        }
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/models/packages.ts
 **/